import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61a9c5a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "tab-card" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-card-info" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tab-card-t" }, "纪检学习"),
  /*#__PURE__*/_createElementVNode("div", { class: "tab-card-dec" }, "太阳每天都是新的")
], -1))
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-card-info" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tab-card-t" }, "专项答题"),
  /*#__PURE__*/_createElementVNode("div", { class: "tab-card-dec" }, "术业有专攻")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-title" }, "排行榜", -1))
const _hoisted_8 = { class: "list-content" }
const _hoisted_9 = { class: "list-item-left" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ranking" }, null, -1))
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "name" }
const _hoisted_13 = { class: "list-item-right" }
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "×", -1))
const _hoisted_16 = { class: "person-score" }
const _hoisted_17 = { class: "list-item" }
const _hoisted_18 = { class: "list-item-left" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "name" }
const _hoisted_21 = { style: {"color":"#8893a3","font-size":"12px"} }
const _hoisted_22 = { class: "list-item-right" }
const _hoisted_23 = ["src"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "×", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_empty = _resolveComponent("van-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "tab-card-item",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'Disciplinestudy' })))
      }, [
        _createElementVNode("img", {
          class: "tab-card-icon",
          src: require('@/assets/disciplinesafe/meiridati.png')
        }, null, 8, _hoisted_3),
        _hoisted_4
      ]),
      _createElementVNode("div", {
        class: "tab-card-item",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'Disciplinetest' })))
      }, [
        _createElementVNode("img", {
          class: "tab-card-icon",
          src: require('@/assets/disciplinesafe/zhuanxiangdati.png')
        }, null, 8, _hoisted_5),
        _hoisted_6
      ])
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      (_ctx.list.length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.list, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["list-item", { _one: index === 0, _two: index === 1, _three: index === 2 }]),
              key: index
            }, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("img", {
                  class: "avtor",
                  src: item.photoUrl
                }, null, 8, _hoisted_11),
                _createElementVNode("div", _hoisted_12, _toDisplayString(item.name), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("img", {
                  class: "score-svg",
                  src: require('@/assets/disciplinesafe/xx.png')
                }, null, 8, _hoisted_14),
                _hoisted_15,
                _createTextVNode(_toDisplayString(item.point), 1)
              ])
            ], 2))
          }), 128))
        : (_openBlock(), _createBlock(_component_van_empty, {
            key: 1,
            description: "暂无排名"
          }))
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("img", {
            class: "avtor",
            src: _ctx.userInfo.photoUrl
          }, null, 8, _hoisted_19),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.userInfo.name), 1),
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.rankCompare(_ctx.point)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("img", {
            class: "score-svg",
            src: require('@/assets/disciplinesafe/xx.png')
          }, null, 8, _hoisted_23),
          _hoisted_24,
          _createTextVNode(_toDisplayString(_ctx.point), 1)
        ])
      ])
    ])
  ]))
}